import axios from 'axios';
import { SERVER_URL } from 'constants';
import { GIG_STATUS_CODES } from './api_constants';

export const BASE_URL = `${SERVER_URL}/api`;
export const getAllUsers = async () => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/users`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getAllGigs = async (providerId) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/dashboard/giglistbyprovider/${providerId}`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};
export const getGigsBasedOnStatus = async (statusId) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/dashboard/giglistbyapprovalstatus/${statusId}`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getGigsBasedOnStatus2 = async (statusId, pageNumber, pageSize) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/dashboard/gigsbyapprovalstatusid?approvalStatusid=${statusId}&pageNumber=${pageNumber+1}&pageSize=${pageSize}`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};


export const getGigsByActiveStatus = async (statusId, pageNumber, pageSize) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/dashboard/gigsbyactivestatus?isActive=${statusId}&pageNumber=${pageNumber}&pageSize=${pageSize}`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const gigById = async (gigId) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/gig/${gigId}`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getUserById = async (userId) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/users/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getAllBannerImages = async () => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/admin/bannerimage`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getJobsCount = async () => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/admin/jobscount`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getComplaintsCount = async () => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/complaint/complaintscount`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getWizerCommission = async () => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/admin/wizercommission`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getComplaints = async () => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const result = await axios.get(`${BASE_URL}/v1/complaint/listforadmin`, { headers: { Authorization: `Bearer ${token}` } });
  return result;
};

export const getToken = async (email, password) => {
  const response = await axios.post(`${BASE_URL}/tokens`, { email, password }, { headers: { Tenant: `root` } });
  return response;
};

export const updateSeekerInfo = async (id, data) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.put(`${BASE_URL}/users/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
  return response;
};
export const newUserAccount = async (data) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.post(`${BASE_URL}/users/admin-createuser`, data, {
    headers: { Authorization: `Bearer ${token}`, tenant: 'root' }
  });
  return response;
};

export const updateProviderInfo = async (id, data) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.put(`${BASE_URL}/users/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
  return response;
};

export const uploadBanner = async (formData) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.post(`${BASE_URL}/v1/admin/bannerimage`, formData, { headers: { Authorization: `Bearer ${token}` } });
  return response;
};

export const deleteBanner = async (id) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.delete(`${BASE_URL}/v1/admin/bannerimage?BannerID=${id}`, { headers: { Authorization: `Bearer ${token}` } });
  return response;
};
export const toggleUserActivation = async (adminId, userId, action) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.post(
    `${BASE_URL}/users/${adminId}/toggle-status`,
    {
      activateUser: action,
      userId: userId
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response;
};
export const toggleGigStatus = async (id, status) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.post(
    `${BASE_URL}/v1/gig/pause-activate`,
    {
      gigid: id,
      isActive: status
    },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response;
};
export const updateGig = async (id, data) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.put(
    `${BASE_URL}/v1/gig/${id}`, data, { headers: { Authorization: `Bearer ${token}` } }
  );
  return response;
};

export const approveandrejectcomplaint = async (complaintID, statusID) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.post(
    `${BASE_URL}/v1/complaint/approveandrejectcomplaint?ComplaintID=${complaintID}&StatusID=${statusID}`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response;
};

export const approveGig = async (id) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.post(
    `${BASE_URL}/v1/admin/gigapprovereject`,
    {
      gigId: id,
      approvalStatusId: GIG_STATUS_CODES.APPROVED,
      //"gigRejectComment": "string"
  },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response;
};
export const rejectGig = async (id, comment) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.post(
    `${BASE_URL}/v1/admin/gigapprovereject`,
    {
      gigId: id,
      approvalStatusId: GIG_STATUS_CODES.REJECTED,
      gigRejectComment: comment
  },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response;
};

export const replaceGigResource = async (gigId, galleryId, payload) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.put(`${BASE_URL}/v1/gig/galary/${gigId}/${galleryId}`, payload, { headers: { Authorization: `Bearer ${token}` } });
  return response;
};

export const deletecomplaint = async (complaintID) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.delete(`${BASE_URL}/v1/complaint/delete-complaint?ComplaintID=${complaintID}`, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
  });

  return response;
};

export const deleteGallerySource = async (id) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.delete(`${BASE_URL}/v1/gig/galary/${id}`, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
  });

  return response;
};

export const deleteGig = async (id) => {
  const token = localStorage.getItem('serviceToken') || 'NO_TOKEN_API_WILL_FAIL';
  const response = await axios.delete(`${BASE_URL}/v1/gig/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  return response;
};
